module.exports = __webpack_public_path__ + "img/appBarMobile.f2a12652.png";